import cekomLogo from "../../../assets/images/CEKOM-logo-sm.png";
import defaultLogo from "../../../assets/images/km-logo.png";
import { labels } from "../../../localization/labels";

export const setCekomTheme = () => {
  // green #74ba57
  // yellow #ffde7f
  // gray #f5f5f5
  // orange #f1a424
  // darker gray #e5e5e5
  // deep dark gray #333333
  // black #000000
  const properties = {
    "background-image": `url("/iStock-608505608v2.jpg")`,
    "primary-color": "#f1a424",
    "primary-background": "#f5f5f5",
    "submenu-background": "#e5e5e5",
    "infoWidgetHeader-background-color": "#f1a424",
    "ant-menu-item-selected-background-color": "#f1a424",
    "primary-title-font-color": "#ffffff",
    "secondary-title-font-color": "#333333",
    "ant-menu-submenu-title": "#333333",
    "table-header-container-bg-color": "#f1a424",
    "button-success": "#f1a424",
    "bg-topBar": "#f5f5f5",
    "button-topBar": "#000f20",
    "button-general": "#f1a424",
    "button-link": "#74ba57",
    "page-link-text": "#f1a424",
    "ant-menu-arrow": "#001f40",
    "ant-menu-arrow-hover": "#f1a424",
    "bar-chart": "#74ba57",
    "dropdown-hover": "#fae1b7",
    "dropdown-selected": "#f1a424",
    "sidemenu-title": "#000f20"
  };
  setTheme(properties);
};

export const setTheme = properties => {
  Object.keys(properties).forEach(key => {
    document.documentElement.style.setProperty(`--${key}`, properties[key]);
  });
};

export const getCekomLogo = () => {
  return { logoSrc: cekomLogo, logoName: labels.applicationCekom };
};
export const getDefaultLogo = () => {
  return { logoSrc: defaultLogo, logoName: labels.applicationNameLong };
};
